
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop, Watch } from 'vue-property-decorator'
import { IFlexMessageSpan } from '@/utils/types'

@Options({
  components: {},
  directives: { maska },
  emits: ['update:modelValue', 'update:validateValue'],
})
export default class Span extends Vue {
  @Prop()
  modelValue!: IFlexMessageSpan

  @Prop()
  isAdmin!: boolean

  get value() {
    return this.modelValue
  }

  set value(value: IFlexMessageSpan) {
    this.$emit('update:modelValue', value)
  }

  get typeList() {
    return [
      {
        label: 'スパン',
        value: 'span',
      },
    ]
  }

  get sizeList() {
    return ['xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl', '3xl', '4xl', '5xl']
  }

  colorValidate(val) {
    if (!val) return true
    return /^#[0-9A-Fa-f]{6}([0-9A-Fa-f]{2})?$/.test(val)
  }

  sizeValidate(val) {
    if (!val) return true

    const isPx = /^\d+(\.\d+)?px$/.test(val)
    const isKeyword = this.sizeList.includes(val)
    return !(!isPx && !isKeyword)
  }

  @Watch('value', { deep: true })
  async validate() {
    await this.$nextTick(async () => {
      const isValid = await this.$refs.formRef.validate()
      if (isValid) {
        this.$emit('update:validateValue', true)
      } else {
        this.$emit('update:validateValue', false)
      }
      return isValid
    })
  }

  mounted() {
    this.validate()
  }
}
